// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.svg-icon[data-v-0ad481a9] {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.15em;\n    fill: currentColor;\n    overflow: hidden;\n    transition: all ease 0.3s;\n}\n@keyframes rotating-0ad481a9{\nfrom{transform:rotate(0)}\nto{transform:rotate(360deg)}\n}\n.rotate[data-v-0ad481a9] {\n    animation:rotating-0ad481a9 1.2s linear infinite\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
